import React, { useState } from 'react';
import { Reveal, Eyebrow } from '../components/Reveal';

function FaqItem({ q, a, idx, testid }) {
  const [open, setOpen] = useState(idx === 0);
  return (
    <div className="border-b border-steelline/60" data-testid={`${testid}-item-${idx}`}>
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        aria-expanded={open}
        data-testid={`${testid}-toggle-${idx}`}
        className="w-full flex items-start justify-between gap-6 py-5 text-left group"
      >
        <h3 className="font-display font-bold text-base md:text-lg text-paper group-hover:text-flame transition-colors">{q}</h3>
        <span className={`font-mono text-flame text-xl leading-none mt-0.5 transition-transform duration-300 ${open ? 'rotate-45' : ''}`} aria-hidden="true">+</span>
      </button>
      <div className={`grid transition-[grid-template-rows] duration-300 ease-out ${open ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'}`}>
        <div className="overflow-hidden min-h-0">
          <p className="text-sm md:text-base text-fog leading-relaxed pb-5 pr-10">{a}</p>
        </div>
      </div>
    </div>
  );
}

export default function Faq({ faqs, eyebrow = 'FAQ', heading, testid = 'faq' }) {
  return (
    <section className="py-20 lg:py-28 border-t border-steelline/60" data-testid={`${testid}-section`}>
      <div className="mx-auto max-w-7xl px-5 lg:px-8 grid lg:grid-cols-12 gap-10">
        <Reveal className="lg:col-span-4">
          <Eyebrow className="mb-4">{eyebrow}</Eyebrow>
          <h2 className="font-display font-extrabold text-2xl sm:text-3xl lg:text-4xl text-paper tracking-tight">{heading}</h2>
        </Reveal>
        <Reveal delay={0.15} className="lg:col-span-8">
          <div className="border-t border-steelline/60">
            {faqs.map((f, i) => <FaqItem key={f.q} {...f} idx={i} testid={testid} />)}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
